import { ReactNode } from 'react';
import { Box, Container, Link, Stack, Typography, alpha } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { PLATFORM_BRAND } from '../../constants/platformLegal';

export default function PublicLegalLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f8fafc',
        backgroundImage: `radial-gradient(ellipse at top, ${alpha('#2563eb', 0.08)}, transparent 55%)`,
      }}
    >
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        <Stack spacing={0.5} sx={{ mb: 3 }}>
          <Typography variant="overline" color="text.secondary" fontWeight={800} letterSpacing="0.12em">
            {PLATFORM_BRAND}
          </Typography>
          <Typography variant="h4" fontWeight={800} letterSpacing="-0.03em">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 640, lineHeight: 1.6 }}>
              {subtitle}
            </Typography>
          )}
          <Stack direction="row" spacing={2} sx={{ pt: 1 }}>
            <Link component={RouterLink} to="/privacy" underline="hover" fontWeight={700} fontSize="0.875rem">
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/delete-account" underline="hover" fontWeight={700} fontSize="0.875rem">
              Delete Account
            </Link>
          </Stack>
        </Stack>
        {children}
      </Container>
    </Box>
  );
}
